import React from "react";
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import Fab from '@material-ui/core/Fab';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import Link from '@material-ui/core/Link';


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    arrowUpwardButton: {
      position: 'absolute',
      top: '85%',
      right: '10%',
      // eslint-disable-next-line
      ['@media (min-width:780px)']: {
      }
    }
  }),
);


const ArrowUpward: React.FC = () => {
  const classes = useStyles();

  return (
    <div>
      <Link href="#MainSection">
        <Fab
          color="primary"
          aria-label="upward"
          className={classes.arrowUpwardButton}
        >
          <ArrowUpwardIcon />
        </Fab>
      </Link>
    </div>
  );
}

export default ArrowUpward;
